import { Component, EventEmitter, OnInit, Type, Output } from '@angular/core';
import { FormFieldBaseComponent } from '../form-field-base/form-field-base.component';
import { FormFieldPropertyEnum } from '../../../models/form-builder/form-field-property-enum.model';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { FlexibleSelectionFieldService } from '../../../services/flexible-selection-field.service';

@Component({
    selector: 'app-flex-field-buttons-form-field',
    templateUrl: './flex-field-buttons-form-field.component.html',
    styleUrl: './flex-field-buttons-form-field.component.scss',
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: FlexFieldButtonsFormFieldComponent,
            multi: true
        }
    ],
    standalone: false
})
export class FlexFieldButtonsFormFieldComponent extends FormFieldBaseComponent implements OnInit {
    @Output() onInit = new EventEmitter();
    @Output() onPropertyUpdated = new EventEmitter();

    private readonly formFieldProperties: string[] =
        [
            FormFieldPropertyEnum.HELP_TEXT,
            FormFieldPropertyEnum.SELECT_OPTIONS,
            FormFieldPropertyEnum.INSTRUCTIONS_TEXT
        ];

    constructor(private flexibleSelectionFieldService: FlexibleSelectionFieldService){
        super();
    }

    public ngOnInit(): void {
        let hshProperties = this.getProperties();

        this.onInit.emit(hshProperties);
    }

    public getProperties() {
        let hshProperties =
        {
            component: this,
            formField: this.formField,
            properties: this.formFieldProperties,

            propertyUpdateRequired: true
        };

        return (hshProperties);
    }

    public handleApply() {
        this.flexibleSelectionFieldService.applyFlexFieldValues();
    }

    public handleClear() {
        this.flexibleSelectionFieldService.clearFlexFieldValues();
    }

    public getFormFieldClass(): Type<any> {
        throw new Error('Method not implemented.');
    }

}
